/**
 * The carousel_name value for the Recommended for You carousel. AuctionCard
 * matches on this exact string to decide whether a card click should also
 * feed the ranking-rationale-label LD experiment's click-occurrence metric —
 * import this constant rather than retyping the literal, so a rename can't
 * silently stop that metric with no compile error.
 */
export const PERSONALIZED_CATEGORIES_CAROUSEL_NAME = 'personalized_categories'
